export const iconFontAwesomeHumanitarianTreeCity = (
	<i className="fa-solid fa-tree-city"></i>
);
